@for (msg of messages; track msg) {
  <div class="ab-container {{ msg.theme }}"
       [style.--ab-dismiss-duration]="msg.dismissMs ? msg.dismissMs + 'ms' : null"
       (mouseenter)="onPointerEnter(msg)"
       (mouseleave)="onPointerLeave(msg)"
       (focusin)="onFocusIn(msg)"
       (focusout)="onFocusOut(msg)">
    <span class="ab-time">{{ msg.time }} @if (msg.reference) {
      <span>- {{ msg.reference }}</span>
    }</span>
    @if (msg.copied) {
      <span class="ab-copied">Copied!</span>
    }
    @if (isError(msg)) {
      <button type="button" class="icon-button ab-copy-icon" aria-label="Copy all error details"
              matTooltip="Copy error details" matTooltipShowDelay="500" (click)="copyToClipboard(msg)">
        <mat-icon fontIcon="content_copy"></mat-icon>
      </button>
    }
    <button type="button" class="icon-button ab-close-icon" aria-label="Close notification"
            matTooltip="Close notification" matTooltipShowDelay="500" (click)="onClose(msg)">
      <i class="bhi-times"></i>
    </button>
    <h2 class="ab-messagearea" (dblclick)="copyToClipboard(msg)">{{ msg.message }}</h2>
    <p class="ab-detailsarea" (dblclick)="copyToClipboard(msg)" [innerHTML]="msg.details"></p>
    <mat-icon class="ab-icon-background"
      [fontIcon]="msg.theme === 'info' ? 'info' : msg.theme === 'error' ? 'error' : 'check_circle'">
    </mat-icon>
    @if (msg.dismissMs) {
      <span class="ab-progress-bar" [class.paused]="msg.paused" aria-hidden="true"></span>
    }
  </div>
}
